import { gql } from '@apollo/client';

import { PROPOSAL_DOCUMENT_FIELDS } from './query';

export const REQUEST_PROPOSAL_DOCUMENT_MUTATION = gql`
  ${PROPOSAL_DOCUMENT_FIELDS}
  mutation RequestProposalDocument($input: RequestProposalDocumentInput!) {
    requestProposalDocument(input: $input) {
      ...ProposalDocumentFields
    }
  }
`;
